module.exports = __webpack_public_path__ + "static/media/S (98).5ad7a54f.jpg";